import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetTempDocumentsParams } from "apis/data-contracts";

/* 임시 저장 문서 목록 조회 */
export const useTempDocumentsQuery = (
  { categoryUuid = "" }: Partial<GetTempDocumentsParams>,
  enabled?: boolean,
) => {
  const query = { categoryUuid };

  return useQuery({
    queryKey: api.document.getTempDocumentsKey(query),
    queryFn: () => api.document.getTempDocuments(query),
    select: (data) => data.data.result,
    enabled,
  });
};
